<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10m-1.8 1.9a7 7 0 0 0-7 7q.2 1 1.2 1.1h15.2q1 0 1.1-1.2a7 7 0 0 0-7-7z"
    />
  </svg>
</template>
